import TextField from './text-field-class.js';

document.querySelectorAll('.js-text-field__input-date').forEach(elem=>new TextField(elem));